import { render, staticRenderFns } from "./KongTiao.vue?vue&type=template&id=46413558&scoped=true&"
import script from "./KongTiao.vue?vue&type=script&lang=js&"
export * from "./KongTiao.vue?vue&type=script&lang=js&"
import style0 from "./KongTiao.vue?vue&type=style&index=0&id=46413558&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46413558",
  null
  
)

export default component.exports